import React from 'react'
import PropTypes from 'prop-types'
import MUIGrid from 'material-ui/Grid'

const styles = {
  flexBasis: 'auto'
}

const Grid = (props) => {
  const {safariFix, children, style, ...gridProps} = props
  let composedStyle = style
  if (safariFix === true) {
    composedStyle = {...style, ...styles}
  }
  return (
    <MUIGrid {...gridProps} style={composedStyle}>
      {children}
    </MUIGrid>
  )
}

Grid.propTypes = {
  safariFix: PropTypes.bool,
}

export default Grid



// WEBPACK FOOTER //
// ./src/common/components/Grid.js